import isPropertySupportedByScaleType from '../parsers/scale/isPropertySupportedByScaleType';
import { continuousScaleTypesSet, discretizingScaleTypesSet, discreteScaleTypesSet } from '../parsers/scale/scaleCategories';
export function isContinuousScaleConfig(config) {
  return continuousScaleTypesSet.has(config.type);
}
export function isDiscretizingScaleConfig(config) {
  return discretizingScaleTypesSet.has(config.type);
}
export function isDiscreteScaleConfig(config) {
  return discreteScaleTypesSet.has(config.type);
}
export function isScaleConfigWithZero(config) {
  return isPropertySupportedByScaleType('zero', config.type);
}